import { createContext, useContext } from 'react';
import type { SessionInfo } from '@avh/shared';

export interface SessionContextValue {
  session: SessionInfo | null;
  /** Rolle Admin oder Ticket */
  canManageTickets: boolean;
  /** Rolle Admin oder Web */
  canManageWebsite: boolean;
  /** Rolle Admin */
  canManageUsers: boolean;
  signIn: (session: SessionInfo) => void;
  signOut: () => void;
}

export const SessionContext = createContext<SessionContextValue | null>(null);

export function useSession(): SessionContextValue {
  const value = useContext(SessionContext);
  if (!value) {
    throw new Error('useSession must be used inside <SessionProvider>');
  }
  return value;
}
